
import React from "react";
import { useParams, Link } from "react-router-dom";
import { crauzetProducts  } from "./RailwaycrauzetPage";
import "./VisionSystemDetails.css";

export default function CrauzetPageDetails() {
  const { id } = useParams();
  const product = crauzetProducts.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Product Not Found</h2>
        <Link to="/">Go Back</Link>
      </div>
    );
  }

  
  return (
    <div className="product-details">
      <img src={product.img} alt={product.title} className="product-image" />
      <div className="product-info">
        <h1>{product.title}</h1>
        <p>{product.desc}</p>
        <Link to="/crauzet" className="back-btn">
          ← Back to Products
        </Link>
      </div>
    </div>
  );
}
